import React, { FC, useEffect, useState } from 'react'

interface ConfirmationModalState {
  display: boolean,
  type: string,
  name: string,
  callback?: VoidFunction
}

interface Props {
  confirmationModalState: ConfirmationModalState
  closeCallback: VoidFunction
}

const ConfirmationModal: FC<Props> = (props) => {
  const {
    confirmationModalState,
    closeCallback,
  } = props

  const [scrollY, setScrollY] = useState<number>(0)

  const [title, setTitle] = useState<string>("")
  const [buttonText, setButtonText] = useState<string>("")

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (confirmationModalState.display) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [confirmationModalState.display])

  useEffect(() => {
    if (confirmationModalState.type === "delete" || confirmationModalState.type === "label_master_delete") {
      setTitle("削除")
      setButtonText("削除する")
    } else if (confirmationModalState.type === "request") {
      setTitle("アプリ申請")
      setButtonText("申請する")
    } else if (confirmationModalState.type === "copy") {
      setTitle("プロジェクトコピー")
      setButtonText("コピーする")
    } else if (confirmationModalState.type === "power_delete") {
      setTitle("権限の削除")
      setButtonText("削除する")
    } else if (confirmationModalState.type === "exclude_delete") {
      setTitle("作業データ生成除外の解除")
      setButtonText("解除する")
    } else if (confirmationModalState.type === "category_delete") {
      setTitle("プロジェクトカテゴリーの削除")
      setButtonText("削除する")
    } else if (confirmationModalState.type === "labeling_condition_delete") {
      setTitle("自動仕分け設定の削除")
      setButtonText("削除する")
    } else if (confirmationModalState.type === "labeling_condition_disable") {
      setTitle("自動仕分け設定の無効化")
      setButtonText("無効化する")
    }
  }, [confirmationModalState])

  // NOTE: type->classNameのmapper, 専用タイトルを持たせつつ、ボタン色は既存の汎用クラスを流用できる
  const buttonColorClass: { [type: string]: string } = {
    labeling_condition_delete: "delete",
    labeling_condition_disable: "stop",
    delete: "delete",
    category_delete: "delete",
    label_master_delete: "delete",
  }

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${confirmationModalState.display || 'none'}`} style={{ width: "500px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  {title}
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                {
                  (confirmationModalState.type === "delete" || confirmationModalState.type === "labeling_condition_delete") && (
                    <>
                      <p>
                        <span id="delete-member-name">{`「${confirmationModalState.name}」`}</span>
                        を削除します。削除すると復元することはできません。
                      </p>
                      <p>
                        本当に削除しますか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "label_master_delete" && (
                    <>
                      <p>
                        <span id="delete-member-name">{`「${confirmationModalState.name}」`}</span>
                        を削除します。削除すると復元することはできません。
                      </p>
                      <p>
                        本当に削除しますか？
                      </p>
                      <p>
                        過去の仕分け済みデータは削除されず、 プロジェクトレポートにて集計されます。
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "request" && (
                    <>
                      <p>
                        <span>{confirmationModalState.name}</span>
                      </p>
                      <p>
                        アプリケーションを認識できるように申請をおこないます。
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "copy" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        のコピーをおこないます。
                      </p>
                      <p>
                        ※所属チームはコピーされません
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "power_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        さんの権限を削除します。よろしいですか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "exclude_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        さんの作業データ生成除外を解除します。よろしいですか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "category_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        を削除します。
                      </p>
                      <p>
                        また、
                        {confirmationModalState.name}
                        を親カテゴリーとするプロジェクトカテゴリーも削除されます。
                      </p>
                      <p>
                        削除してもよろしいですか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "labeling_condition_disable" && (
                    <p>
                      <span id="disable-condition-name">{`「${confirmationModalState.name}」`}</span>
                      を無効化します。よろしいですか？
                    </p>
                  )
                }
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  キャンセル
                </button>
                <button
                  type="button"
                  className={`button ${buttonColorClass[confirmationModalState.type] || confirmationModalState.type}`}
                  onClick={() => {
                    confirmationModalState.callback?.()
                    closeCallback()
                  }}
                >
                  {buttonText}
                </button>
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
    </>
  )
}

export default ConfirmationModal
